export default "__VITE_ASSET__tm7GjvV6__"